import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import Validator from "validatorjs";
import { IDriver } from "../../classes/Domain";

const VALIDATION = {
    INVALID_INCIDENT_CATEGORY: "Category is required",
    INVALID_INCIDENT_VIOLATION: "Violation is required"
};


Validator.registerImplicit('valid_category', function (this: any, value, requirement, attribute) {
    const driver = this.validator.input as IDriver;

    if (driver.incidents && driver.incidents.some(x => x.category === "")) {
        return false;
    }

    return true;
});

Validator.registerImplicit('valid_violation', function (this: any, value, requirement, attribute) {
    const driver = this.validator.input as IDriver;

    if (driver.incidents && driver.incidents.some(x => x.violationCode === "")) {
        return false;
    }

    return true;
});


const rules = {
    //licenseSuspendedRevokedFiveYears: 'required',
    sr22: 'required',
    studentGood: 'required',
    defensiveDriver: 'required',
    physiciansReport: 'required',
    accidentsViolations: 'required',
    incidents: {
        category: 'valid_category',
        violationCode: 'valid_violation'
    }
};

const customErrorMessages = {
    "valid_category": VALIDATION.INVALID_INCIDENT_CATEGORY,
    "valid_violation": VALIDATION.INVALID_INCIDENT_VIOLATION,
};

export const allFieldsValidation = (data, stateCode: string | null = null) => {
    const driver = data as IDriver;

    if (driver && !driver.isExcluded && stateCode && stateCode === "TX") {
        rules.sr22 = 'required';
    }
    else {
        delete rules["sr22"];
    }

    return allFieldsValidationCommon(data, rules, { ...customErrorMessagesCommon, ...customErrorMessages });
};